/* global Swiper */
const sliderBox = {
	el: {
		sliderContainerCommand: document.querySelectorAll('.js-slider-box-command'),
		sliderContainerController: document.querySelectorAll('.js-slider-box-controller')
	},

	fxInitSlider(el, elementControll) {
		const sliderPaginationType = el.dataset.sliderPaginationType ? el.dataset.sliderPaginationType : ''

		const swiperOptions = {
			watchOverflow: true,
			navigation: {
				nextEl: el.parentElement.querySelector('.swiper-button-next'),
				prevEl: el.parentElement.querySelector('.swiper-button-prev')
			},

			pagination: {
				el: el.querySelector('.swiper-pagination'),
				clickable: true,
				type: sliderPaginationType ? sliderPaginationType : 'bullets' //"bullets", "fraction", "progressbar" or "custom"  (default:"bullets")
			},

			on: {
				init: () => setTimeout(() => window.dispatchEvent(new Event('resize')), 100)
			}
		}

		// this way we can define which swiper instace controls the other
		new Swiper(el, swiperOptions).controller.control = new Swiper(elementControll)
	},

	init() {
		this.el.sliderContainerController.forEach(el => {
			const previousElement = el.parentElement.previousElementSibling.querySelector('.js-slider-box-command')
			this.fxInitSlider(el, previousElement)
		})

		// this is the slider that controlls the other
		this.el.sliderContainerCommand.forEach(el => {
			const nextElement = el.parentElement.nextElementSibling.querySelector('.js-slider-box-controller')
			this.fxInitSlider(el, nextElement)
		})
	}
}
sliderBox.init()